/**
 * Cart LocalStorage Utilities
 * Manages cart persistence in localStorage
 */

const CART_STORAGE_KEY = "nbyula_cart";

/**
 * Save cart to localStorage
 */
export function saveCartToStorage(cart) {
  try {
    const cartData = {
      items: cart.items || [],
      total: cart.total || 0,
      lastUpdated: new Date().toISOString(),
    };
    localStorage.setItem(CART_STORAGE_KEY, JSON.stringify(cartData));
  } catch (error) {
    console.error("Error saving cart to localStorage:", error);
  }
}

/**
 * Load cart from localStorage
 */
export function loadCartFromStorage() {
  try {
    const cartData = localStorage.getItem(CART_STORAGE_KEY);
    if (!cartData) {
      return null;
    }

    const parsedCart = JSON.parse(cartData);

    // Optional: Add expiration check (e.g., 7 days)
    const lastUpdated = new Date(parsedCart.lastUpdated);
    const daysSinceUpdate = (new Date() - lastUpdated) / (1000 * 60 * 60 * 24);

    if (daysSinceUpdate > 7) {
      // Cart is too old, clear it
      clearCartStorage();
      return null;
    }

    return {
      items: parsedCart.items || [],
      total: parsedCart.total || 0,
      showCart: false, // Don't auto-show on load
    };
  } catch (error) {
    console.error("Error loading cart from localStorage:", error);
    return null;
  }
}

/**
 * Clear cart from localStorage
 */
export function clearCartStorage() {
  try {
    localStorage.removeItem(CART_STORAGE_KEY);
  } catch (error) {
    console.error("Error clearing cart from localStorage:", error);
  }
}
